//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';

import { faArrowUp, faThumbsUp, faPhotoFilmMusic } from '@fortawesome/pro-solid-svg-icons';
import { faMeAlbumCollection } from '@/assets/icons/me-font-icons-regular.js';
import { publishedContentCounts, renderContentCount } from '@motionelements/core/src/helpers/contentCount.js';

export default {
  name: 'HomeBenefits',
  props: {
    squareIcons: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      faArrowUp,
      faMeAlbumCollection,
      faThumbsUp,
      faPhotoFilmMusic,
    };
  },
  computed: {
    ...mapState({
      uiMode: state => state.user.preferences.ui.mode,
    }),
    subscriptionElementCount() {
      return renderContentCount(this, publishedContentCounts.total.subscription.element);
    },
  },
};
